// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { PageInfoFragment } from '../../../graphql/fragments/pageInfo.fragment.generated';
import { gql } from '@apollo/client';
import { PageInfoFragmentDoc } from '../../../graphql/fragments/pageInfo.fragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ClientListAdvisorClientFragment = { __typename?: 'Household', id: string, archivedAt?: Time | null, billableKind: Types.HouseholdBillableKind, notes?: string | null, private: boolean, hasPendingValidationQuestions?: boolean, displayName: string, createdAt: Time, primaryRelationshipOwner: { __typename?: 'User', id: string, displayName: string }, estateValueMetrics: { __typename?: 'HouseholdMetrics', totalEstateValue: CurrencyUSD }, possiblePrimaryClients: Array<{ __typename?: 'ClientProfile', id: string, createdAt: Time, address?: { __typename?: 'Address', id: string, stateCode: string } | null }>, subBrand?: { __typename?: 'SubBrand', id: string, displayName: string } | null, assignedTeams?: Array<{ __typename?: 'Team', id: string, name: string }> | null, integrationClients?: Array<{ __typename?: 'IntegrationClient', id: string, kind: Types.IntegrationClientKind }> | null };

export type ListClientsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.HouseholdWhereInput>;
  orderBy?: Types.InputMaybe<Array<Types.HouseholdOrder> | Types.HouseholdOrder>;
  first: Types.Scalars['Int']['input'];
  after?: Types.InputMaybe<Types.Scalars['Cursor']['input']>;
  query: Types.Scalars['String']['input'];
  skipTeams: Types.Scalars['Boolean']['input'];
  includeValidationStatus?: Types.Scalars['Boolean']['input'];
}>;


export type ListClientsQuery = { __typename?: 'Query', paginatedData: { __typename?: 'HouseholdConnection', totalCount: number, pageInfo: (
      { __typename?: 'PageInfo' }
      & PageInfoFragment
    ), edges?: Array<{ __typename?: 'HouseholdEdge', node?: (
        { __typename?: 'Household', id: string }
        & ClientListAdvisorClientFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    ListClients: 'ListClients' as const
  },
  Fragment: {
    ClientListAdvisorClient: 'ClientListAdvisorClient' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const ClientListAdvisorClientFragmentDoc = gql`
    fragment ClientListAdvisorClient on Household {
  id
  archivedAt
  billableKind
  notes
  private
  hasPendingValidationQuestions @include(if: $includeValidationStatus)
  primaryRelationshipOwner {
    id
    displayName
  }
  displayName
  estateValueMetrics(source: {kind: HOUSEHOLD}) {
    totalEstateValue
  }
  possiblePrimaryClients {
    id
    createdAt
    address {
      id
      stateCode
    }
  }
  createdAt
  subBrand {
    id
    displayName
  }
  assignedTeams @skip(if: $skipTeams) {
    id
    name
  }
  integrationClients {
    id
    kind
  }
}
    `;
export const ListClientsDocument = gql`
    query ListClients($where: HouseholdWhereInput, $orderBy: [HouseholdOrder!], $first: Int!, $after: Cursor, $query: String!, $skipTeams: Boolean!, $includeValidationStatus: Boolean! = false) {
  paginatedData: searchHouseholds(
    where: $where
    orderBy: $orderBy
    first: $first
    after: $after
    query: $query
  ) {
    totalCount
    pageInfo {
      ...PageInfo
    }
    edges {
      node {
        id
        ...ClientListAdvisorClient
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${ClientListAdvisorClientFragmentDoc}`;

/**
 * __useListClientsQuery__
 *
 * To run a query within a React component, call `useListClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListClientsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      query: // value for 'query'
 *      skipTeams: // value for 'skipTeams'
 *      includeValidationStatus: // value for 'includeValidationStatus'
 *   },
 * });
 */
export function useListClientsQuery(baseOptions: Apollo.QueryHookOptions<ListClientsQuery, ListClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListClientsQuery, ListClientsQueryVariables>(ListClientsDocument, withFetchPolicyContext(options));
      }
export function useListClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListClientsQuery, ListClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListClientsQuery, ListClientsQueryVariables>(ListClientsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useListClientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListClientsQuery, ListClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListClientsQuery, ListClientsQueryVariables>(ListClientsDocument, withFetchPolicyContext(options));
        }
export type ListClientsQueryHookResult = ReturnType<typeof useListClientsQuery>;
export type ListClientsLazyQueryHookResult = ReturnType<typeof useListClientsLazyQuery>;
export type ListClientsSuspenseQueryHookResult = ReturnType<typeof useListClientsSuspenseQuery>;
export type ListClientsQueryResult = Apollo.QueryResult<ListClientsQuery, ListClientsQueryVariables>;